import {
  AssignGradesGrants,
  BidsGrants,
  DockReceiptGrants,
  DropShipmentGrants,
  LocationPrefixesGrants,
  ItemLocationsGrants,
  PoSummaryGrants,
  PrepLogGrants,
  ReceivePoGrants,
  SerialInGrants,
  SoDispatcherGrants,
  TradeInGrants,
  DeviceAuditGrants,
  LobsGrants,
  ShipFromWarehouseGrants,
  FileUploadGrants,
  CategoryMappingGrants,
  DeviceQueryScreenGrants,
  ReportsDesignerGrants,
  ReportsGrants,
  UserManagementGrants,
} from 'security-grants';

export const RoutePermissions: {
  [key: string]:
    | AssignGradesGrants
    | BidsGrants
    | DockReceiptGrants
    | DropShipmentGrants
    | PoSummaryGrants
    | PrepLogGrants
    | ReceivePoGrants
    | SerialInGrants
    | SoDispatcherGrants
    | TradeInGrants
    | LocationPrefixesGrants
    | ItemLocationsGrants
    | DeviceAuditGrants
    | LobsGrants
    | ShipFromWarehouseGrants
    | FileUploadGrants
    | CategoryMappingGrants
    | DeviceQueryScreenGrants
    | ReportsDesignerGrants
    | ReportsGrants
    | UserManagementGrants;
} = {
  'bid-management': BidsGrants.BIDS_OPEN,
  'trade-in': TradeInGrants.TRADE_IN_OPEN,
  'receive-po': ReceivePoGrants.RECEIVE_PO_OPEN,
  'po-summary': PoSummaryGrants.PO_SUMMARY_OPEN,
  'serial-in': SerialInGrants.SERIAL_IN_OPEN,
  'assign-grades': AssignGradesGrants.ASSIGN_GRADES_OPEN,
  'so-dispatcher': SoDispatcherGrants.SO_DISPATCHER_OPEN,
  'drop-ship': DropShipmentGrants.DROP_SHIPMENT_OPEN,
  'prep-log': PrepLogGrants.PREP_LOG_OPEN,
  'dock-receipt': DockReceiptGrants.DOCK_RECEIPT_OPEN,
  'location-prefixes': LocationPrefixesGrants.LOCATION_PREFIXES_OPEN,
  'item-locations': ItemLocationsGrants.ITEM_LOCATIONS_OPEN,
  'device-audit': DeviceAuditGrants.DEVICE_AUDIT_OPEN,
  lob: LobsGrants.LOBS_OPEN,
  'ship-from-warehouse': ShipFromWarehouseGrants.SHIP_FROM_WAREHOUSE_OPEN,
  'file-upload': FileUploadGrants.FILE_UPLOAD_OPEN,
  'category-mapping': CategoryMappingGrants.CATEGORY_MAPPING_OPEN,
  'device-query-screen': DeviceQueryScreenGrants.DEVICE_QUERY_SCREEN_OPEN,
  'reports-designer': ReportsDesignerGrants.REPORTS_DESIGNER_OPEN,
  reports: ReportsGrants.REPORTS_OPEN,
  users: UserManagementGrants.USER_MANAGEMENT_OPEN,
};
